<app-page-layout>
  <app-page-bar>
    <app-bar-back-button [link]="['/']"
                         [tooltip]="'Главная'"></app-bar-back-button>
    <app-bar-title>Пользователи</app-bar-title>
    <button mat-icon-button *ngIf="canAdd"
            matTooltip="Добавить пользователя"
            (click)="openUserCreateDialog()">
      <mat-icon>add</mat-icon>
    </button>
  </app-page-bar>
  <app-page-content>
    <app-user-filters
      [filters]="filters"
      (apply)="onFiltersChange($event)"></app-user-filters>
    <mat-divider></mat-divider>
    <app-users-table
      [displayedColumns]="displayedColumns"
      [sort]="sort"
      [dataSource]="dataSource"
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"></app-users-table>
  </app-page-content>
</app-page-layout>
